// extracted by mini-css-extract-plugin
module.exports = {"flex":"Flex_flex__zS7sS","flexColumn":"Flex_flexColumn__3JJRT","sidebar":"Flex_sidebar__33YQk","mainContent":"Flex_mainContent__8Sie2"};